/* eslint-disable jsx-a11y/no-static-element-interactions */
import * as React from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Box, Typography } from "@mui/material";
import styles from "./styles.module.css";
import * as calendarData from "../functions/calendarData";
import * as calFns from "../functions/calendarFunctions";
import { t } from "../../translate";
import { getAdMonthRangeFromBsMoth } from "../functions/calendarFunctions";

enum Switch {
  month,
  year
}

export interface YearMonthSwitchProps {
  onSwitch: (year: number, month: number) => void;
  defaultYear: number;
  defaultMonth: number;
}

export interface YearMonthSwitchState {
  currentYear: number;
  currentMonth: number;
  activeSwitch: Switch;
}

const YearMonthSwitch: React.FC<YearMonthSwitchProps> = ({
  onSwitch,
  defaultYear,
  defaultMonth
}) => {
  const [state, setState] = React.useState({
    currentYear: defaultYear,
    currentMonth: defaultMonth,
    activeSwitch: Switch.month
  });

  React.useEffect(() => {
    setState({ ...state, currentYear: defaultYear, currentMonth: defaultMonth });
  }, [defaultMonth, defaultYear]);

  const setCurrent = (currentYear = state.currentYear, currentMonth = state.currentMonth) => {
    setState({ ...state, currentMonth, currentYear });
    onSwitch(currentYear, currentMonth);
  };

  const goBack = () => {
    if (state.activeSwitch === Switch.year && calendarData.minBsYear < state.currentYear) {
      setCurrent(state.currentYear - 1);
    }
    if (state.activeSwitch === Switch.month) {
      let currentMonth = state.currentMonth - 1;
      let { currentYear } = state;
      if (currentMonth === 0) {
        currentMonth = 12;
        currentYear = state.currentYear - 1;
      }
      if (calendarData.minBsYear <= currentYear) {
        setCurrent(currentYear, currentMonth);
      }
    }
  };

  const goForward = () => {
    if (state.activeSwitch === Switch.year && calendarData.maxBsYear > state.currentYear) {
      setCurrent(state.currentYear + 1);
    }
    if (state.activeSwitch === Switch.month) {
      let currentMonth = state.currentMonth + 1;
      let { currentYear } = state;
      if (currentMonth > 12) {
        currentMonth = 1;
        currentYear = state.currentYear + 1;
      }
      if (calendarData.maxBsYear >= currentYear) {
        setCurrent(currentYear, currentMonth);
      }
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div
        className={`r-n-cal-switch ${styles.switch}`}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <div
          className={`r-n-cal-backBtn ${styles.btns} ${styles.backBtn}`}
          onClick={() => goBack()}
        >
          <ChevronLeftIcon />
        </div>
        <Typography
          className={`r-n-cal-yearBtn  ${
            state.activeSwitch === Switch.year ? styles.activeSwitch : ""
          }`}
          onClick={() => setState({ ...state, activeSwitch: Switch.year })}
          style={{ fontWeight: 700 }}
        >
          {calFns.toDevanagariDigits(state.currentYear)}
        </Typography>
        <Typography
          className={`r-n-cal-monthBtn   ${
            state.activeSwitch === Switch.month ? styles.activeSwitch : ""
          }`}
          onClick={() => setState({ ...state, activeSwitch: Switch.month })}
          style={{ fontWeight: 700 }}
        >
          {calendarData.bsMonths(t)[state.currentMonth - 1]}
        </Typography>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <div
          className={`r-n-cal-forwardBtn ${styles.btns} ${styles.forwardBtn}`}
          onClick={() => goForward()}
          style={{ textAlign: "right" }}
        >
          <ChevronRightIcon />
        </div>
      </div>
      <Box sx={{ display: "flex", flexDirection: "column", mb: 0.5 }}>
        <Typography variant="body2">
          {getAdMonthRangeFromBsMoth(state.currentYear, state.currentMonth)}
        </Typography>
      </Box>
    </Box>
  );
};

export default YearMonthSwitch;
